import { render, staticRenderFns } from "./Stash.vue?vue&type=template&id=c2823a58&scoped=true"
import script from "./Stash.vue?vue&type=script&lang=js"
export * from "./Stash.vue?vue&type=script&lang=js"
import style0 from "./Stash.vue?vue&type=style&index=0&id=c2823a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2823a58",
  null
  
)

export default component.exports